export default __webpack_public_path__ + "static/media/demo-img.a4f142c1.png";